
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/visita-les-instalacions/[slug]",
      function () {
        return require("private-next-pages/corporatiu/visita-les-instalacions/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/visita-les-instalacions/[slug]"])
      });
    }
  